<template>
  <div class="department-announcement">
    <div style="margin-bottom: 10px" class="df both-side">
      <a-space>
        <a-select
          :options="departmentOptions"
          v-model:value="requestPayload.originalDept"
          placeholder="发送部门"
          style="width: 200px"
          allowClear
          @change="handleSelectOriginalDept"
        ></a-select>
        <a-select
          :options="departmentOptions"
          v-model:value="requestPayload.translDept"
          placeholder="接收部门"
          style="width: 200px"
          allowClear
          @change="handleSelectTransDept"
        ></a-select>
        <a-input
          v-model:value="requestPayload.translDeptNotice"
          placeholder="公告"
          style="width: 200px"
          allowClear
          @change="handleSearch"
        >
        </a-input>
      </a-space>
      <a-button @click="handleUpdate(null)">新增</a-button>
    </div>

    <department-announcemt-form
      ref="formRef"
      @handleUpdateTable="handleUpdateTable"
    ></department-announcemt-form>

    <div style="height: calc(100vh - 220px)">
      <a-table
        :data-source="table.data"
        bordered
        :pagination="false"
        :columns="columns"
        :scroll="{ y: 'calc(100vh - 340px)', x: 'calc(100vw - 300px)' }"
        rowKey="id"
      >
        <template #createTime="{ record }">
          {{ timeStampToTime(record.createTime, "upload") }}
        </template>

        <template #file="{ record }">
          <echo-file :file="record.fileLink"></echo-file>
        </template>

        <template #action="{ record }">
          <a-space>
            <a-button
              type="primary"
              @click="handleUpdate(record)"
              size="small"
              :disabled="actionAuthority(record)"
              >修改</a-button
            >

            <a-button
              type="danger"
              size="small"
              @click="handleDelete(record)"
              :disabled="actionAuthority(record)"
            >
              删除
            </a-button>
          </a-space>
        </template></a-table
      >
    </div>

    <div class="df both-side">
      <div></div>
      <a-pagination
        size="small"
        :total="table.total"
        :show-total="(total) => `共 ${total} 条`"
        v-model:current="table.pageNum"
        v-model:pageSize="table.lineNum"
        @change="hanldeUpdatePageNum"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, ref } from "vue";
import { debounce, timeStampToTime } from "@/utils/index";
import { useTable } from "@/views/notice/serve/table";
import { useStore } from "vuex";
import {
  deleteTransDeptNotice,
  getTransDeptNoticeList,
} from "@/request/view/transDept";

import { getDepartmentOptions } from "@/views/transDepartment/departmentAnnouncement/options";

import echoFile from "@/views/rdmanagement/components/file";

import departmentAnnouncemtForm from "@/views/transDepartment/departmentAnnouncement/form.vue";

export default defineComponent({
  components: {
    echoFile,
    departmentAnnouncemtForm,
  },
  setup() {
    const {
      requestConfig,
      table,
      requestPayload,
      initPayload,
      getListData,
      searchData,
      deleteRecords,
      hanldeUpdatePageNum,
    } = useTable();

    const store = useStore();

    const user = store.state.user.user;

    const formRef = ref();

    const actionAuthority = (record) => {
      return user.id !== record.userId;
    };

    initPayload({
      pageNum: table.pageNum,
      lineNum: table.lineNum,
      originalDept: null,
      translDept: null,
      translDeptNotice: null,
    });

    const columns = [
      {
        title: "序号",
        dataIndex: "customId",
        align: "center",
      },
      {
        title: "创建时间",
        slots: {
          customRender: "createTime",
        },
        align: "center",
      },
      {
        title: "跨部门公告",
        dataIndex: "translDeptNotice",
        align: "center",
      },
      {
        title: "文件",
        slots: {
          customRender: "file",
        },
        align: "center",
      },
      {
        title: "发送部门",
        dataIndex: "originalDept",
        align: "center",
      },
      {
        title: "接收部门",
        dataIndex: "translDept",
        align: "center",
      },
      {
        title: "发送人",
        dataIndex: "username",
        align: "center",
      },
      {
        title: "操作",
        slots: {
          customRender: "action",
        },
        align: "center",
      },
    ];

    requestConfig.pull_fn = getTransDeptNoticeList;
    requestConfig.delete_fn = deleteTransDeptNotice;

    const handleUpdate = (record) => {
      const title = record ? "修改跨部门通知" : "新增跨部门通知";
      const type = record ? "update" : "insert";
      formRef.value.showModal(type, {
        title,
        data: record,
      });
    };

    const handleDelete = (record) => {
      deleteRecords([record.id], { title: "确认删除？" }).then(() => {
        getData();
      });
    };

    const getData = () => {
      getListData().then(() => {
        table.data.forEach((item, index) => {
          item.customId = index + 1 + (table.pageNum - 1) * table.lineNum;
        });
      });
    };

    // 选择跨部门
    const handleSelectTransDept = (e) => {
      // requestPayload.originalDept = e ? null : user.firstLevelDepartment;
      getData();
    };

    // 选择发送部门
    const handleSelectOriginalDept = (e) => {
      // requestPayload.translDept = e;
      getData();
    };

    getData();

    const handleSearch = debounce(() => {
      table.pageNum = 1;
      getData();
    }, 50);

    const departmentOptions = getDepartmentOptions();

    const handleUpdateTable = () => {
      requestPayload.translDept = null;
      requestPayload.translDeptNotice = null;
      table.pageNum = 1;
      getData();
    };

    return {
      table,
      formRef,
      columns,
      requestPayload,
      departmentOptions,
      hanldeUpdatePageNum,
      handleSelectTransDept,
      handleSelectOriginalDept,
      actionAuthority,
      handleSearch,
      timeStampToTime,
      handleUpdateTable,
      handleDelete,
      handleUpdate,
    };
  },
});
</script>

<style lang="less" scoped>
.department-announcement {
  width: 100%;
  height: calc(100vh - 120px);
  box-shadow: 0 0 5px 0 #ccc;
  border-radius: 15px;
  background: #fff;
  padding: 20px;
}
</style>
